import { createContext } from 'react';

import { AccountsContextType } from './AccountsContext.types';

const initialContext: AccountsContextType = {
  accounts: [],
  addAccount: () => null,
  removeAccount: () => null,
  resetActiveAccount: () => null,
  setActiveAccount: () => null,
  updateAccount: () => null,
};

export const AccountsContext = createContext(initialContext);
